import { Progress as AntdProgress, type ProgressProps } from 'antd'

export const Progress = (props: ProgressProps) => <AntdProgress {...props} />
